import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const ArrowCircleDownIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };

  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.25C6.34614 22.25 1.75 17.6539 1.75 12C1.75 6.34614 6.34614 1.75 12 1.75C17.6539 1.75 22.25 6.34614 22.25 12C22.25 17.6539 17.6539 22.25 12 22.25ZM12 2.25C6.62386 2.25 2.25 6.62386 2.25 12C2.25 17.3761 6.62386 21.75 12 21.75C17.3761 21.75 21.75 17.3761 21.75 12C21.75 6.62386 17.3761 2.25 12 2.25Z"
        fill="currentColor"
        stroke="white"
      />
      <path
        d="M11.6465 13.5536L12 13.9071L12.3536 13.5536L15.3536 10.5536C15.4483 10.4588 15.6117 10.4588 15.7065 10.5536C15.8012 10.6483 15.8012 10.8117 15.7065 10.9064L12.1765 14.4364C12.1252 14.4877 12.0646 14.51 12 14.51C11.9355 14.51 11.8749 14.4877 11.8236 14.4364L8.29359 10.9064C8.19885 10.8117 8.19885 10.6483 8.29359 10.5536C8.38833 10.4588 8.55174 10.4588 8.64648 10.5536L11.6465 13.5536Z"
        fill="currentColor"
        stroke="white"
      />
    </svg>
  );
};
const ArrowCircleDownIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={ArrowCircleDownIconSVG}
      style={{
        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default ArrowCircleDownIcon;
